export default __webpack_public_path__ + "static/media/SwapArrowIcon.0d574991.svg";